import { groupCloudEnvironmentRows } from "../../cmmd/cloudEnvironmentGrouping";
import { forgeCloudEnvironmentLabelForRow } from "../../environments/forgeCloudEnvironmentLabel";
import { useForgeCloudEnvironmentNamingContext } from "../../environments/useForgeCloudEnvironmentNamingContext";
import type { CloudExecutionTargetsSectionProps } from "./CloudExecutionTargetsSection";
import { CloudRuntimeExecutionRow } from "./CloudRuntimeExecutionRow";

/** Stands in when a caller offers no recovery, so a row never calls undefined. */
const noopRecoverCloudEnvironment = () => undefined;

type CloudEnvironmentRowsProps = Pick<
  CloudExecutionTargetsSectionProps,
  | "busyCloudProjectKey"
  | "busyCloudActionLabel"
  | "onRepairCloudWorkspace"
  | "onRecoverCloudEnvironment"
  | "onDeleteEnvironment"
  | "onRemoveCloudProject"
  | "onUpdateCloudRuntime"
  | "onRunCloudRuntimeLifecycleAction"
  | "onEnvironmentRenamed"
> & {
  readonly groups: ReturnType<typeof groupCloudEnvironmentRows>;
};

/** One row per Environment, each named by the label every other surface uses. */
export function CloudEnvironmentRows({
  groups,
  busyCloudProjectKey,
  busyCloudActionLabel,
  onRepairCloudWorkspace,
  onRecoverCloudEnvironment = noopRecoverCloudEnvironment,
  onDeleteEnvironment,
  onRemoveCloudProject,
  onUpdateCloudRuntime,
  onRunCloudRuntimeLifecycleAction,
  onEnvironmentRenamed,
}: CloudEnvironmentRowsProps) {
  const namingContext = useForgeCloudEnvironmentNamingContext();
  return groups.map((group) => (
    <CloudRuntimeExecutionRow
      key={group.environmentId}
      // Read from the ROW, so each Environment is named by its own
      // Organization, and another Seat's by its own owner.
      environmentName={forgeCloudEnvironmentLabelForRow(group.environment, namingContext)}
      environment={group.environment}
      rows={group.rows}
      busyCloudProjectKey={busyCloudProjectKey}
      busyCloudActionLabel={busyCloudActionLabel}
      onRepair={onRepairCloudWorkspace}
      onRecover={onRecoverCloudEnvironment}
      onDeleteEnvironment={onDeleteEnvironment}
      onRemoveProject={onRemoveCloudProject}
      onUpdate={onUpdateCloudRuntime}
      onRunLifecycleAction={onRunCloudRuntimeLifecycleAction}
      onRenamed={onEnvironmentRenamed}
    />
  ));
}
